import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'

interface Props {
  onSubmit: () => void
  onClose: () => void
}

const DeleteRuleModal = ({ onSubmit, onClose }: Props) => {
  const handleSubmit = () => {
    onClose()
    onSubmit()
  }

  return (
    <Modal
      title="Delete rule"
      description="Are you sure you want to delete this rule? This action cannot be undone."
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={handleSubmit}>Delete</Button>
        </>
      }
      onClose={onClose}
      illustration="alert"
    />
  )
}

export default DeleteRuleModal
